import {queueParams} from './queue-params';
const states=new Set(['draft','submitted','ready','processing','partially_settled','settled','on_hold','canceled']);
export function paymentQueueParams(filters={}) {
    const selected=queueParams({billingaccount_ids:filters.billingaccount_ids,invoice_ids:undefined});
    const entries=filters.state==null || filters.state==='' ? [] : Array.isArray(filters.state) ? filters.state : String(filters.state).split(',');
    const values=entries.map(item=>typeof item==='object' ? item.value : item);
    if(values.some(value=>!states.has(value))) throw new Error('Invalid payment state.');
    const ordering=filters.ordering || 'scheduled_date';
    if(!['scheduled_date','amount','state','updated_at'].includes(ordering.replace(/^-/,''))) throw new Error('Invalid payment ordering.');
    return {...selected,...(values.length ? {state:[...new Set(values)].join(',')} : {}),ordering,limit:Math.min(100,Math.max(1,Number(filters.limit)||50)),offset:Math.max(0,Number(filters.offset)||0)};
}
